export const SIGN_UP = '/signup';
export const FIND_AUDIO = '/library';
export const ADD_AUDIO = '/manage-library';
export const EDIT_AUDIO = '/edit-track';
export const SIGN_IN = '/';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const ADMIN = '/admin';
export const ADMINUSERS = '/admin';
export const ADMINFIELDS = '/admin/fields';
export const PASSWORD_FORGET = '/forgot-password';
export const ADMINCHATBOT = '/admin/chatbot'; //chatbot feature
export const ADMINANALYTICS = '/admin/analytics';
export const ADMINREPORTING = '/admin/reporting';
// Global Organization Manager — gated to MasterOrg admins. CRUD on
// /organizations, /broadcaster, /mediaowner, owner assignment, and change log.
export const ADMIN_GLOBAL_ORGS = '/admin/global-organizations';
export const INVITE = '/invite/:code';
export const CLAIM_LICENSE = '/claim/:claimCode';
export const REVIEW_SPOT = '/review/:reviewCode';
export const DELIVERY = '/delivery/:deliveryCode';
export const RAPID_UPLOAD = '/upload/:uploadCode';
export const JOBS = '/jobs';
export const JOB_DETAIL = '/jobs/:jobId';
export const SELECT_ORGANIZATION = '/select-organization';
export const GET_STARTED = '/get-started';
export const PUBLIC_CATALOGUE = '/public-tracks';
export const MASTER_LIBRARY = '/master-library';
export const PUBLIC_LIBRARY = '/public-library';

// Custom Modules — bespoke, per-client tools that live inside RV but are
// gated to explicitly-authorised orgs. Access is controlled per-org via
// the /customModules/{moduleId} document's `authorisedOrgIds` array,
// managed in the /admin/modules admin page (super-admin + master-org
// ADMIN only).
export const MODULES_INDEX = '/modules';
// Individual modules — one route per client. Kept explicit rather than
// dynamic so tree-shaking and code-splitting can lazy-load only what
// the current org is authorised to see.
export const MODULE_CHECKERS = '/modules/checkers';
export const MODULE_SHOPRITE = '/modules/shoprite';
export const MODULE_OK_FOODS = '/modules/ok-foods';
export const ADMIN_MODULES = '/admin/modules';

// Delivery Overrides Admin — gated to MasterOrg admins + super-admins.
// A per-org grid granting/revoking access to the Delivery Overrides
// settings. Access is stored on organizations/{orgId}.deliveryOverridesEnabled;
// an org with it enabled sees the DeliveryOverridesEditor on its own
// /admin/organization page and self-configures the individual bypasses.
export const ADMIN_DELIVERY_OVERRIDES = '/admin/delivery-overrides';
